import React, { useState, useEffect, useRef } from 'react'
import debounce from 'lodash/debounce'

interface MenuSearchBarProps {
  className: string
  placeholder: string
  onQueryChange: (query: string) => void
}

const MenuSearchBar = ({ className, placeholder, onQueryChange }: MenuSearchBarProps) => {
  const [searchInput, setSearchInput] = useState<string>('')

  const debouncedQueryChange = useRef(
    debounce((value: string) => {
      onQueryChange(value)
    }, 500)
  ).current

  useEffect(() => {
    return () => {
      debouncedQueryChange.cancel()
    }
  }, [debouncedQueryChange])

  const updateSearchInput = (newInput: string) => {
    setSearchInput(newInput)
    debouncedQueryChange(newInput)
  }

  const handleSearch = () => {
    debouncedQueryChange.cancel()
    onQueryChange(searchInput)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <div className={className}>
      <input
        type="text"
        placeholder={placeholder}
        className="search-input"
        value={searchInput}
        onChange={(e) => updateSearchInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button type="button" className="search-btn" onClick={handleSearch}>Search</button>
    </div>
  )
}

export default MenuSearchBar
